{
  "Quantity": "Quantité",
  "Item": "Article",
  "CMEnvironment": "CMEs",
  "TelephonyServer": "Serveur de téléphonie",
  "Partitions": "Cloisons",
  "Devices": "Dispositifs",
  "Agents": "Agents",
  "ReportingUsers": "Utilisateurs de rapports",
  "NonReportingUsers": "Utilisateurs non déclarants",
  "Estate_ButtonHelpLabel": "De l'aide ?",
  "Estate_ButtonSubmitLabel": "OK",
  "Estate_ButtonCancelLabel": "Annuler",
  "Estate_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
  "Estate_PromptConfirm": "Oui",
  "Estate_PromptCancel": "Annuler",
  "NAME": "Estate"
}